export class Adresse {
    static jsonMap = {
        idJure: 'idJure',
        idIntervenant: 'idIntervenant',
        idSite: 'idSite',
        idRefAdresseType: 'idRefAdresseType',
        adresse: 'adresse',
        complement: 'complement',
        codePostal: 'codePostal',
        ville: 'ville'
    };

    idJure: number;
    idIntervenant: number;
    idSite: number;
    idRefAdresseType: number;
    adresse: string;
    complement: string;
    codePostal: string;
    ville: string;

    constructor(data?: Partial<Adresse>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
